import Vue from "vue";
import { errorServeiceHandler, makeQueryFormDataDyn } from "../../helper";

const actions = {
  actPostFileUpload: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/fileupload", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (context.getters.getMode == "development") {
            resolve();
          } else {
            resolve(data);
          }
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve();
          }
          console.log("error", error);
          reject(error);
        });
    });
  },
  actPutKYC: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      var object = {};
      data.forEach(function(value, key) {
        object[key] = value;
      });
      data = JSON.stringify(object);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber", {
        method: "PUT",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (context.getters.getMode == "development") {
            resolve();
          } else {
            resolve(data);
          }
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve();
          }
          reject(error);
        });
    });
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/myprofile/kyc.js